import { render, staticRenderFns } from "./manual-add.vue?vue&type=template&id=a466fe74&scoped=true&"
import script from "./manual-add.vue?vue&type=script&lang=js&"
export * from "./manual-add.vue?vue&type=script&lang=js&"
import style0 from "./manual-add.vue?vue&type=style&index=0&id=a466fe74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a466fe74",
  null
  
)

export default component.exports